<template>
  <!--Legende -->
  <div
    class="fixed right-0 z-50 p-0 mt-4 transition-all duration-500 shadow-lg bg-base-100 card top-32"
    :class="{
      'translate-x-[calc(100%-2rem)] h-40 ': !openLegend,
      'translate-x-0 ': openLegend
    }"
  >
    <div
      :class="{
        'opacity-0 pointer-events-none': openLegend,
        'opacity-100 pointer-events-auto': !openLegend
      }"
      @click="openLegend = !openLegend"
      class="absolute flex items-center justify-between h-full py-4 text-2xl font-bold rotate-180 text-secondary-content bg-secondary"
      style="writing-mode: vertical-rl; text-orientation: mixed"
    >
      <span>Legende</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6 scale-100 -rotate-90 cursor-pointer animate-pulse hover:scale-110 hover:animate-none"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
        />
      </svg>
    </div>
    <div class="p-0 card-body">
      <div
        @click="openLegend = !openLegend"
        class="flex items-center justify-between px-2 py-1 text-2xl font-bold gap-x-4 card-title bg-secondary text-secondary-content"
      >
        <span>Legende</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 scale-100 cursor-pointer animate-pulse hover:scale-110 hover:animate-none"
          :class="{ '-rotate-90': openLegend, 'rotate-180': !openLegend }"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
          />
        </svg>
      </div>

      <div
        ref="legenddata"
        class="flex flex-col px-4 py-2 transition-all duration-100 delay-0 gap-y-1"
      >
        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center rounded-full bg-1-non-institutionelle text-secondary-content"
          >
            PPN
          </div>
          <span>Partie Prénante Non Institutionnelle</span>
        </div>
        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center rounded-full bg-2-institutionelle text-primary-content"
          >
            PPI
          </div>
          <span>Partie Prénante Institutionnelle</span>
        </div>
        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center rounded-full bg-3-financier text-accent-content"
          >
            PF
          </div>
          <span class="whitespace-nowrap"
            >Partenaire Technique et Financier</span
          >
        </div>

        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-6 text-xl font-bold text-center rounded-full bg-1-engage text-base-100"
          >
            +
          </div>
          <span class="whitespace-nowrap">Acteur Engagé</span>
        </div>

        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-6 text-xl font-bold text-center rounded-full bg-2-peu-engage text-base-100"
          >
            -
          </div>
          <span class="whitespace-nowrap">Acteur Peu Engagé</span>
        </div>

        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-6 text-xl font-bold text-center rounded-full bg-3-indecis text-base-100"
          >
            !
          </div>
          <span class="whitespace-nowrap">Acteur Indecis</span>
        </div>

        <div class="flex items-center gap-x-2" v-if="!relations">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs font-bold text-center rounded-full ring-1 ring-red-700 text-base-100"
          >
            <div
              class="flex items-center justify-center w-6 h-6 text-xs font-bold text-center rounded-full ring-1 ring-red-700 text-base-100"
            >
              <div
                class="flex items-center justify-center w-4 h-4 text-xs font-bold text-center rounded-full ring-1 ring-red-700 text-base-100"
              >
                <div
                  class="flex items-center justify-center w-2 h-2 text-xs font-bold text-center rounded-full ring-1 ring-red-700 text-base-100"
                >
                  <div
                    class="flex items-center justify-center w-1 h-1 text-xs font-bold text-center bg-red-700 rounded-full text-base-100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <span> Niveau d'influence </span>
        </div>
        <template v-if="relations">
          <h1 class="mt-2 font-bold">Relations</h1>
          <template v-for="(rel, index) of relations" :key="index">
            <div class="flex items-center gap-x-2">
              <i
                :style="{
                  color: rel.color
                }"
                class="flex items-center justify-center w-4 h-4 text-xl text-center fas"
                :class="rel.icon"
              ></i>
              <div
                class="relative flex items-center justify-center w-12 h-1 text-xs text-center "
              >
                <svg
                  v-if="[0, 0].includes(rel.id)"
                  height="13"
                  class="self-center"
                  :width="50"
                  style="background: transparent"
                >
                  <line
                    x1="0"
                    y1="4"
                    :x2="50"
                    y2="4"
                    style="stroke-width: 4"
                    :style="{
                      stroke: relations.find(x => x.id == rel.id)?.color
                    }"
                  />
                  <line
                    x1="0"
                    y1="8"
                    :x2="50"
                    y2="8"
                    style="stroke: rgba(255, 0, 255, 0); stroke-width: 4"
                  />
                  <line
                    x1="0"
                    y1="12"
                    :x2="50"
                    y2="12"
                    style="stroke: rgba(255, 0, 0, 0.6); stroke-width: 6"
                    :style="{
                      stroke: relations.find(x => x.id == rel.id)?.color
                    }"
                  />
                </svg>

                <svg
                  v-if="[2, 4].includes(rel.id)"
                  height="13"
                  class="self-center"
                  :width="50"
                  style="background: transparent"
                >
                  <line
                    x1="0"
                    y1="4"
                    :x2="50"
                    y2="4"
                    style="stroke: rgba(255, 0, 255, 0); stroke-width: 4"
                  />
                  <line
                    v-for="multiple of Math.ceil(50 / 20)"
                    :key="multiple"
                    :x1="20 * (multiple - 1) + (multiple > 1 ? 5 : 0)"
                    y1="8"
                    :x2="multiple * 20"
                    y2="8"
                    style="stroke-width: 4"
                    :style="{
                      stroke: relations.find(x => x.id == rel.id)?.color
                    }"
                  />
                  <line
                    x1="0"
                    y1="12"
                    :x2="50"
                    y2="12"
                    style="stroke: rgba(255, 0, 255, 0); stroke-width: 6"
                  />
                </svg>

                <svg
                  v-if="[3].includes(rel.id)"
                  height="13"
                  class="self-center"
                  :width="50"
                  style="background: transparent"
                >
                  <line
                    x1="0"
                    y1="4"
                    :x2="50"
                    y2="4"
                    style="stroke: rgba(255, 0, 255, 0); stroke-width: 4"
                  />
                  <line
                    v-for="multiple of Math.ceil(50 / 8)"
                    :key="multiple"
                    :x1="8 * (multiple - 1) + (multiple > 0 ? 3 : 0)"
                    y1="8"
                    :x2="multiple * 8"
                    y2="8"
                    style="stroke-width: 4"
                    :style="{
                      stroke: relations.find(x => x.id == rel.id)?.color
                    }"
                  />
                  <line
                    x1="0"
                    y1="12"
                    :x2="50"
                    y2="12"
                    style="stroke: rgba(255, 0, 255, 0); stroke-width: 6"
                  />
                </svg>

                <svg
                  v-if="[1, 5].includes(rel.id)"
                  height="13"
                  class="self-center"
                  :width="50"
                  style="background: transparent"
                >
                  <line
                    x1="0"
                    y1="4"
                    :x2="50"
                    y2="4"
                    style="stroke: rgba(255, 0, 255, 0); stroke-width: 4"
                  />
                  <line
                    :x1="0"
                    y1="8"
                    :x2="50"
                    y2="8"
                    style="stroke-width: 4"
                    :style="{
                      stroke: relations.find(x => x.id == rel.id)?.color
                    }"
                  />
                  <line
                    x1="0"
                    y1="12"
                    :x2="50"
                    y2="12"
                    style="stroke: rgba(255, 0, 255, 0); stroke-width: 6"
                  />
                </svg>
              </div>
              <span>{{ rel.text }}</span>
            </div>
          </template>
        </template>
      </div>

      <a class="btn btn-primary" @click="$emit('download')"
        >Editer le rapport</a
      >
    </div>
  </div>
  <!-- Fin  Legende -->
</template>

<script>
export default {
  name: "LegendAPP",
  props: {
    relations: Array
  },
  data() {
    return {
      openLegend: false
    };
  },

  methods: {
    getLengendElement() {
      return this.$refs.legenddata;
    }
  }
};
</script>

<style></style>
